'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'user';
var width = 448;
var height = 512;
var aliases = [128100,62144,62470,"user-alt","user-large"];
var unicode = 'f007';
var svgPathData = 'M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM33.5 512l54.2-176 272.7 0 54.2 176 33.5 0-64-208-320 0-64 208 33.5 0zM224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;